module.exports = __webpack_public_path__ + "img/background038.jpg";